const translation = {
    PageSize: 'Размер страницы',
    PageOrientation: 'Ориентация страницы',
    Format: 'Формат',
    DPI: 'Разрешение (DPI)',
    Title: 'Экспорт карты',
    Close: 'Закрыть',
    Save: 'Сохранить',
    FileName: 'Имя файла',
    Landscape: 'Альбомная',
    Portrait: 'Книжная',
    PreviewHint: 'Перетаскивайте для перемещения, прокручивайте или сводите пальцы для масштабирования области экспорта.',
    ExportFailed: 'Не удалось экспортировать карту. Попробуйте ещё раз.',
    PreviewFailed: 'Не удалось построить предпросмотр.',
    AdjustArea: 'Настроить область на карте',
    AdjustAreaHint: 'Перемещайте, масштабируйте, вращайте или наклоняйте карту, чтобы выбрать область экспорта',
    ZoomIn: 'Увеличить',
    ZoomOut: 'Уменьшить',
    ResetZoom: 'Сбросить масштаб до 100 %',
    Done: 'Готово',
    Cancel: 'Отмена',
    Scalebar: 'Масштабная линейка',
    NorthIcon: 'Указатель севера',
    ChooseNorthIcon: 'Выбрать указатель севера',
    ChooseSvgFile: 'Выбрать файл SVG',
    IconSymbol: 'Символ',
    IconColor: 'Цвет',
    IconSize: 'Размер',
    InvalidSvg: 'Файл не является корректным SVG.',
    ExportAsVector: 'Экспортировать как вектор',
    ExportLabelsAsVector: 'Экспортировать подписи как вектор',
    Custom: 'Пользовательский',
    Width: 'Ширина',
    Height: 'Высота',
    LanguageName: 'русский',
    LanguageCode: 'ru'
};
export default translation;
